import Loadable from 'react-loadable';

export const CrossProductSearch = Loadable({
  loader: () => import(/* webpackChunkName: "CrossProductSearch" */ './CrossProductSearch'),
  loading: () => null,
});
